import { FC } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import i18n from 'i18next';
import { AppRoutes } from 'utils/constants/app/app-routes';
import {
  EasyAccessSections,
  ESportEasyAccessSections,
  RacingEasyAccessSections
} from 'utils/constants/sportsbook/easy-access-sections';
import { PageType } from 'interfaces/generic';
import { SearchElement } from 'newelements/SearchElement';
import { NavSection } from 'components/NavSection';
import './index.less';

type Props = RouteComponentProps & {
  configs: {
    pageType: PageType;
    outterRoutes?: Record<string, string>;
    category: string;
  };
  title?: string;
  externalOnClick?: () => void;
  tooltipOnParent?: boolean;
};

const _SportsbookEasyAccessNavigation: FC<Props> = ({
  configs: { pageType, outterRoutes, category },
  title = category === 'racing'
    ? i18n.t('pages.racing')
    : i18n.t('sportsbook.easyAccess'),
  externalOnClick,
  tooltipOnParent
}) => {
  return (
    <div className="easy-access-box">
      {category === 'sport' && (
        <div className="ea-search">
          <SearchElement />
        </div>
      )}
      <NavSection
        title={title || ''}
        items={
          category === 'esport'
            ? ESportEasyAccessSections
            : category === 'racing'
            ? RacingEasyAccessSections
            : EasyAccessSections
        }
        routes={outterRoutes || AppRoutes}
        pageType={pageType}
        category={category}
        externalOnClick={externalOnClick}
        tooltipOnParent={tooltipOnParent}
      />
    </div>
  );
};

export const SportsbookEasyAccessNavigation:
  | ReturnType<typeof withRouter>
  | any = withRouter(_SportsbookEasyAccessNavigation as any);
